import DetailRelated from './DetailRelated'

export default DetailRelated
// eslint-disable-next-line import/export
export * from './DetailRelated'
